import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
const installImg = "/images/site/walnut-rift-quartered-michigan-plank-floor-dining-area-novi-mi.webp";
import lvpImg from "@/assets/brand-cali-floors.webp";
import laminateImg from "@/assets/waterproof-laminate-entryway-hero.webp";

const types = [
  {
    title: "Hardwood Flooring",
    sub: "Solid, engineered, custom wide-plank and reclaimed. NWFA-certified installation and refinishing.",
    image: installImg,
    imageAlt: "Open dining area with a Michigan Plank rift and quartered walnut floor in 2 to 5 inch widths, Novi, MI",
    href: "/hardwood-flooring",
  },
  {
    title: "Luxury Vinyl Plank",
    sub: "Waterproof, pet friendly, high definition wood look. Mid range budget, showpiece result.",
    image: lvpImg,
    imageAlt: "Cali luxury vinyl plank floor",
    href: "/luxury-vinyl-plank-flooring",
  },
  {
    title: "Laminate Flooring",
    sub: "Quick-Step certified since 1998. Waterproof laminate that does not wear, stain or fade.",
    image: laminateImg,
    imageAlt: "Quick Step waterproof laminate floor in an entryway",
    href: "/laminate-flooring",
  },
];

const FlooringTypesSection = () => (
  <section className="bg-background py-14 md:py-20 lg:py-28">
    <div className="max-w-[1200px] mx-auto px-5 md:px-12">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="mb-8 md:mb-10"
      >
        <p className="text-[11px] font-semibold tracking-[.18em] uppercase text-primary mb-3">
          Flooring Types
        </p>
        <h2 className="font-display text-[clamp(28px,5vw,52px)] font-semibold text-foreground leading-[1.1]">
          Explore by <em className="italic font-normal text-primary">floor type.</em>
        </h2>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-[4px] rounded-[28px] overflow-hidden">
        {types.map((t, i) => (
          <motion.div
            key={t.title}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.06 }}
            className="relative overflow-hidden group aspect-[4/5] md:aspect-[3/4] min-h-[280px] md:min-h-0"
          >
            <Link to={t.href} className="absolute inset-0 block">
              <img
                loading="lazy"
                src={t.image}
                alt={t.imageAlt}
                className="absolute inset-0 w-full h-full object-cover grayscale-[20%] contrast-[1.1] group-hover:grayscale-0 group-hover:scale-[1.05] transition-all duration-[550ms] ease-[cubic-bezier(.25,.46,.45,.94)]"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent" />
              <div className="absolute bottom-0 left-0 p-4 md:p-6">
                <h3 className="font-display font-semibold text-primary-foreground leading-tight text-lg md:text-xl">
                  {t.title}
                </h3>
                <p className="font-light text-primary-foreground/70 mt-1 leading-relaxed text-[14px] md:text-[13px] max-w-xs">
                  {t.sub}
                </p>
                <span className="inline-flex items-center gap-1 text-[14px] md:text-[11px] font-semibold tracking-wide text-gold-400 mt-2 group-hover:text-gold-300 transition-colors">
                  Explore <ArrowRight className="w-3 h-3 transition-transform duration-300 group-hover:translate-x-1" />
                </span>
              </div>
            </Link>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default FlooringTypesSection;
